"use client";
import { useId, useState } from "react";

export function DisclosurePanel({ title, defaultOpen = false, id, headlineRight, children }: {
  title: string; defaultOpen?: boolean; id?: string; headlineRight?: React.ReactNode; children: React.ReactNode;
}) {
  const [open, setOpen] = useState(defaultOpen);
  const reactId = useId();
  const bodyId = `disc-${reactId}`;
  return (
    <section id={id} className="mt-6 bg-white rounded-[18px] border border-border-light overflow-hidden scroll-mt-28">
      <h2>
        <button type="button" onClick={() => setOpen((v) => !v)} aria-expanded={open} aria-controls={bodyId}
          className="flex min-h-11 w-full items-center gap-3 px-5 py-4 text-left outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-teal md:px-7">
          <span className="font-serif text-[18px] md:text-[20px] font-bold text-navy">{title}</span>
          {headlineRight && <span className="text-[12px] text-text-muted">{headlineRight}</span>}
          <span aria-hidden="true" className="ml-auto text-text-muted text-[20px] leading-none">{open ? "－" : "＋"}</span>
        </button>
      </h2>
      {open && (
        <div id={bodyId} className="px-5 md:px-7 pb-6">
          {children}
        </div>
      )}
    </section>
  );
}
